/**
 * AUTO-GENERATED — do not edit by hand.
 * Run: npm run generate:settings-component-loaders
 */
import type { ComponentLoader } from 'src/types/ComponentLoader';

const SETTINGS_COMPONENT_LOADERS_BY_KEY = {
	device_details: () => import('./Settings/DeviceDetails.svelte'),
	device_location: () => import('./Settings/DeviceLocation.svelte'),
	bluetooth_gateway: () => import('./Settings/BluetoothGateway.svelte'),
	note_section: () => import('../Drawer/DeviceDrawer/NoteSection.svelte'),
	information_board: () => import('../Drawer/DeviceDrawer/InformationBoard.svelte'),
	edit_device: () => import('../Drawer/DeviceDrawer/EditDevice.svelte'),
	quick_tour_guide: () => import('../Distance/QuickTourGuide.svelte'),
	introduction_wizard: () => import('../BluLiquidLevel/IntroductionWizard.svelte'),
	auto: () => import('./Timers/TimersG1/Auto.svelte'),
	auto_v2: () => import('./Timers/TimersG1/AutoV2.svelte'),
	schedule_settings: () => import('./Schedules/SchedulesG1/SchedulesG1.svelte'),
	schedule_settings_v2: () => import('./Schedules/SchedulesG1/SchedulesG1V2.svelte'),
	schedules_trv: () => import('./Schedules/SchedulesTRV/SchedulesTrv.svelte'),
	actions: () => import('./WebHooks/WebHooksHelpers/ActionsContext.svelte'),
	actions_v2: () => import('./WebHooks/WebHooksHelpers/ActionsContextV2.svelte'),
	adc_actions: () => import('./WebHooks/WebHooksG1/AdcActions.svelte'),
	adc_automation: () => import('./ExternalSensorSettings/AdcAutomation.svelte'),
	auto_t_trv: () => import('./SensorSettingsG1/Trv/AutoTControlTrv.svelte'),
	illumination_definitions: () => import('./SensorSettingsG1/DoorWindow/IlluminationThreshold.svelte'),
	motion_illumination_definitions: () =>
		import('./SensorSettingsG1/Motion/MotionIlluminationDefinitions.svelte'),
	tilt_functions: () => import('./SensorSettingsG1/DoorWindow/TiltFunctions.svelte'),
	tamper_sensitivity: () => import('./SensorSettingsG1/Motion/TamperSensitivity.svelte'),
	sleep_time: () => import('./SensorSettingsG1/Motion/SleepTime.svelte'),
	vibration: () => import('./SensorSettingsG1/DoorWindow/Vibration.svelte'),
	motion_settings: () => import('./SensorSettingsG1/Motion/MotionSettings/MotionSettings.svelte'),
	motion_configuration_g4: () => import('./SensorSettingsG2/Motion/MotionConfigurationG4.svelte'),
	motion_sensor_settings_g4: () => import('./SensorSettingsG2/Motion/MotionSensorSettingsG4.svelte'),
	presence_ui_settings_g4: () => import('./SensorSettingsG2/Motion/PresenceUISettingsG4.svelte'),
	wake_up_by_lighting: () => import('./SensorSettingsG1/DoorWindow/WakeUpByLighting.svelte'),
	reverse_open_close: () => import('./SensorSettingsG1/DoorWindow/ReverseOpenCloseLogic.svelte'),
	temperature_offset_trv: () => import('./SensorSettingsG1/Trv/TemperatureOffsetTrv.svelte'),
	temperature_threshold: () => import('./SensorSettingsG1/TemperatureThreshold.svelte'),
	temperature_unit: () => import('./SensorSettingsG1/TemperatureUnits.svelte'),
	humidity_threshold: () => import('./SensorSettingsG1/HumidityThreshold.svelte'),
	humidity_offset: () => import('./SensorSettingsG1/HumidityOffset.svelte'),
	temperature_offset: () => import('./SensorSettingsG1/TemperatureOffset.svelte'),
	motion_led: () => import('./SensorSettingsG1/Sense/MotionLed.svelte'),
	motion_duration: () => import('./SensorSettingsG1/Sense/MotionDuration.svelte'),
	external_power: () => import('./SensorSettingsG1/ExternalPower.svelte'),
	sensor_actions: () => import('./WebHooks/WebHooksG1/SensorActions.svelte'),
	valve: () => import('./SensorSettingsG1/Gas/Valve.svelte'),
	rain_mode: () => import('./SensorSettingsG1/Flood/RainMode.svelte'),
	open_window: () => import('./SensorSettingsG1/Trv/OpenWindow.svelte'),
	temperature_unit_g2: () => import('./SensorSettingsG2/TemperatureUnits.svelte'),
	temperature_offset_g2: () => import('./SensorSettingsG2/Offset/TemperatureOffsetG2.svelte'),
	humidity_offset_g2: () => import('./SensorSettingsG2/Offset/HumidityOffsetG2.svelte'),
	temperature_threshold_g2: () => import('./SensorSettingsG2/TemperatureThreshold.svelte'),
	humidity_threshold_g2: () => import('./SensorSettingsG2/HumidityThreshold.svelte'),
	temperature_settings_g2: () => import('./SensorSettingsG2/TemperatureSettingsG2.svelte'),
	humidity_settings_g2: () => import('./SensorSettingsG2/HumiditySettingsG2.svelte'),
	bright_threshold_g2: () => import('./SensorSettingsG2/Illuminance/BrightThresholdG2.svelte'),
	dark_threshold_g2: () => import('./SensorSettingsG2/Illuminance/DarkThresholdG2.svelte'),
	temperature_sensor_name_g2: () => import('./SensorSettingsG2/SensorComponentNameG2.svelte'),
	humidity_sensor_name_g2: () => import('./SensorSettingsG2/SensorComponentNameG2.svelte'),
	illuminance_sensor_name_g2: () => import('./SensorSettingsG2/SensorComponentNameG2.svelte'),
	ventora_temperature_settings: () =>
		import('./SensorSettingsG2/Ventora/VentoraSensorSettingsGroup.svelte'),
	ventora_humidity_settings: () =>
		import('./SensorSettingsG2/Ventora/VentoraSensorSettingsGroup.svelte'),
	ventora_illuminance_settings: () =>
		import('./SensorSettingsG2/Ventora/VentoraSensorSettingsGroup.svelte'),
	alarm_mode_g2: () => import('./SensorSettingsG2/FloodG2/AlarmModeG2.svelte'),
	state_hold_time_g2: () => import('./SensorSettingsG2/FloodG2/StateHoldTimeG2.svelte'),
	presence_configuration: () => import('./SensorSettingsG2/PresenceG4/PresenceConfiguration.svelte'),
	presence_fine_tuning: () => import('./SensorSettingsG2/PresenceG4/PresenceFineTuning.svelte'),
	presence_led_settings: () => import('./SensorSettingsG2/PresenceG4/PresenceLedNightMode.svelte'),
	ext_temperature_unit: () => import('./ExternalSensorSettings/ExtTemperatureUnit.svelte'),
	ext_sensor_names: () => import('./ExternalSensorSettings/ExtSensorNames.svelte'),
	ext_temperature_offset: () => import('./ExternalSensorSettings/ExtTemperatureOffset.svelte'),
	ext_humidity_offset: () => import('./ExternalSensorSettings/ExtHumidityOffset.svelte'),
	advanced_developer_settings: () => import('./NetworkG1/AdvancedDevSettings.svelte'),
	cloud: () => import('./NetworkG1/Cloud.svelte'),
	restrict_login: () => import('./NetworkG1/RestrictLogin.svelte'),
	wifi_ap_roaming: () => import('./NetworkG1/WifiApRoaming.svelte'),
	wifi_client_backup: () => import('./NetworkG1/WifiClientBackup.svelte'),
	wifi_mode_ap: () => import('./NetworkG1/WifiModeAp.svelte'),
	wifi_mode_client: () => import('./NetworkG1/WifiModeClient.svelte'),
	wifi_reconnect: () => import('./NetworkG1/WifiReconnect.svelte'),
	max_power_protection: () => import('./Safety/SafetyG1/PowerProtection.svelte'),
	max_power_protection_em3: () => import('./Safety/SafetyG1/PowerProtectionEM3.svelte'),
	max_power_protection_roller: () => import('./Safety/SafetyG1/PowerProtectionRoller.svelte'),
	obstacle_detection: () => import('./Safety/SafetyG1/ObstacleDetection.svelte'),
	overvoltage_auto_recovery_g2: () => import('./Safety/SafetyG2/OvervoltageAutoRecovery.svelte'),
	over_under_voltage_auto_recovery_g2: () =>
		import('./Safety/SafetyG2/OverUnderVoltageAutoRecovery.svelte'),
	safety_switch: () => import('./Safety/SafetyG1/SafetySwitch.svelte'),
	under_voltage_protection_g2: () => import('./Safety/SafetyG2/UnderVoltageG2.svelte'),
	voltage_protection_g2: () => import('./Safety/SafetyG2/VoltageProtectionG2.svelte'),
	favorites_gen_1: () => import('./Favorites.svelte'),
	antiflickering_debounce: () => import('./Settings/SettingsG1/Antiflickering.svelte'),
	adc_offset: () => import('./Settings/SettingsG1/AdcSettings/AdcOffset.svelte'),
	adc_range: () => import('./Settings/SettingsG1/AdcSettings/AdcRange.svelte'),
	boost_time: () => import('./Settings/SettingsG1/TRV/BoostTime.svelte'),
	button_type: () => import('./Settings/SettingsG1/ButtonTypes/BtnType.svelte'),
	button_type_1l: () => import('./Settings/SettingsG1/ButtonTypes/BtnType1L.svelte'),
	button_type_1l2: () => import('./Settings/SettingsG1/ButtonTypes/BtnType1L2.svelte'),
	button_type_inputs_reader: () =>
		import('./Settings/SettingsG1/ButtonTypes/BtnTypeInputsReader.svelte'),
	button_type_pm: () => import('./Settings/SettingsG1/ButtonTypes/BtnTypePM.svelte'),
	button_type_rgbw2: () => import('./Settings/SettingsG1/ButtonTypes/BtnTypeRGBW2.svelte'),
	button_type_rgbw2white: () => import('./Settings/SettingsG1/ButtonTypes/BtnTypeRGBW2White.svelte'),
	button_type_roller: () => import('./Settings/SettingsG1/ButtonTypes/BtnTypeRoller.svelte'),
	button_type_rr: () => import('./Settings/SettingsG1/ButtonTypes/BtnTypeRR.svelte'),
	button_debounce: () => import('./Settings/SettingsG1/ButtonDebounce.svelte'),
	buttons_fade_rate: () => import('./Settings/SettingsG1/ButtonFade.svelte'),
	calibration_trv: () => import('./Settings/SettingsG1/TRV/CalibrationTrv.svelte'),
	calibration_blu_trv: () => import('./VirtualComponents/BluTRV/BluTrvCalibration.svelte'),
	interface_blu_trv: () => import('./VirtualComponents/BluTRV/BluTrvInterface.svelte'),
	behavior_blu_trv: () => import('./VirtualComponents/BluTRV/BluTrvBehavior.svelte'),
	boost_duration_override: () =>
		import('./VirtualComponents/BluTRV/BluTrvBoostDurationOverride.svelte'),
	boost_blu_trv: () => import('./VirtualComponents/BluTRV/BluTrvBoostSettings.svelte'),
	open_window_target_temperature: () =>
		import('./VirtualComponents/BluTRV/BluTrvDefaultOpenWindowTargetTemp.svelte'),
	enable_blu_trv: () => import('./VirtualComponents/BluTRV/BluTrvEnable.svelte'),
	temperature_offset_blu_trv: () =>
		import('./VirtualComponents/BluTRV/BluTrvTemperatureOffset.svelte'),
	temperature_settings_blu_trv: () =>
		import('./VirtualComponents/BluTRV/BluTrvTemperatureSettings.svelte'),
	firmware_update_blu_trv: () => import('./VirtualComponents/BluTRV/BluTrvFWUpdate.svelte'),
	schedules_blu_trv: () => import('./VirtualComponents/BluTRV/SchedulesBLUTRV.svelte'),
	attached_sensors_blu_trv: () => import('./VirtualComponents/BluTRV/BluTrvAttachedSensors.svelte'),
	temperature_favorite_positions: () => import('../Drawer/DeviceDrawer/TempFavPositions.svelte'),
	channel_name: () => import('./Settings/SettingsG1/ChannelName.svelte'),
	clog_prevention: () => import('./Settings/SettingsG1/TRV/ClogPrevention.svelte'),
	consumption_correction: () => import('./Settings/SettingsG1/ConsumptionCorrection.svelte'),
	consumption_indicator: () => import('./Settings/SettingsG1/ConsumptionIndicator.svelte'),
	customize_device_content: () => import('./CustomizeDeviceContent/CustomizeDeviceContent.svelte'),
	dc_supply_voltage: () => import('./Settings/SettingsG1/DCSupply.svelte'),
	device_name: () => import('./Settings/SettingsG1/DeviceName.svelte'),
	dimmer_calibration: () => import('./Settings/SettingsG1/DimmerCalibration.svelte'),
	display: () => import('./Settings/SettingsG1/TRV/Display.svelte'),
	device_information: () => import('./Settings/CommonSettings/DeviceInfo/DeviceInfo.svelte'),
	maintenance_actions: () => import('./Settings/CommonSettings/MaintenanceActions.svelte'),
	transfer_device: () => import('./Settings/CommonSettings/DeviceInfo/TransferDevice.svelte'),
	delete_device: () => import('./Settings/CommonSettings/DeviceInfo/DeleteDevice.svelte'),
	device_model: () => import('./Settings/SettingsG1/DeviceModel.svelte'),
	device_reboot: () => import('./Settings/CommonSettings/DeviceReboot.svelte'),
	eco_mode: () => import('./Settings/SettingsG1/EcoMode.svelte'),
	ends_delay: () => import('./Settings/SettingsG1/EndsDelay.svelte'),
	mode_rgb2: () => import('./Settings/SettingsG1/ModeRGBW2.svelte'),
	erase_data: () => import('./Settings/SettingsG1/EraseData.svelte'),
	ext_temperature_actions: () => import('./ExternalSensorSettings/TemperatureAutomation.svelte'),
	ext_humidity_actions: () => import('./ExternalSensorSettings/HumidityAutomation.svelte'),
	ext_switch: () => import('./Settings/SettingsG1/ExternalSwitch.svelte'),
	factory_reset: () => import('./Settings/CommonSettings/FactoryReset.svelte'),
	factory_reset_from_input: () => import('./Settings/CommonSettings/FactoryResetFromInput.svelte'),
	factory_reset_g1: () => import('./Settings/SettingsG1/FactoryResetG1.svelte'),
	force_close: () => import('./Settings/SettingsG1/TRV/ForceCloseTrv.svelte'),
	firmware_update: () => import('./Settings/CommonSettings/FirmwareUpdate.svelte'),
	geo_location_and_time_zone: () => import('./Settings/CommonSettings/GeoLocationAndTimeZone.svelte'),
	input_buttons_mode: () => import('./Settings/SettingsG1/ButtonTypes/InputBtnsMode.svelte'),
	kids_protection: () => import('./Settings/SettingsG1/TRV/ChildLock.svelte'),
	led_indicator_color_plus_plug_s: () => import('./Settings/SettingsG2/LedIndicatorColorPlug.svelte'),
	led_indicator_night_mode_plus_plug_s: () =>
		import('./Settings/SettingsG2/LedIndicatorNightModePlug.svelte'),
	led_indicators_plug: () =>
		import('./Settings/SettingsG2/LedIndicatorsPlug/LedIndicatorsPlug.svelte'),
	dimming_behavior_g2: () =>
		import('./Settings/SettingsG2/DimmingBehaviorG2/DimmingBehaviorG2.svelte'),
	led_status_disable: () => import('./Settings/SettingsG1/RelayLightControl.svelte'),
	led_status_disable_plug: () => import('./Settings/SettingsG1/PlugLightControl.svelte'),
	led_light_control: () => import('./Settings/SettingsG1/DWLightControl.svelte'),
	mos_light_control: () => import('./Settings/SettingsG1/MosLightControl.svelte'),
	long_push: () => import('./Settings/SettingsG1/LongPush.svelte'),
	long_push_inputs: () => import('./Settings/SettingsG1/LongPushInputs.svelte'),
	min_brightness: () => import('./Settings/SettingsG1/MinBrightness.svelte'),
	multi_push: () => import('./Settings/SettingsG1/MultiPush.svelte'),
	mode: () => import('./Settings/SettingsG1/Mode.svelte'),
	neutral_mismatch: () => import('./Settings/SettingsG1/NeutralMismatch.svelte'),
	night_mode: () => import('../DevicesSettings/NightMode/NightModeG1/NightMode.svelte'),
	night_mode_v2: () => import('../DevicesSettings/NightMode/NightModeG1/NightModeV2.svelte'),
	night_mode_rgbw: () => import('../DevicesSettings/NightMode/NightModeG1/NightModeRGBW.svelte'),
	night_mode_rgbw_v2: () => import('../DevicesSettings/NightMode/NightModeG1/NightModeRGBWV2.svelte'),
	night_mode_g2: () => import('../DevicesSettings/NightMode/NightModeG2/NightModeG2.svelte'),
	night_mode_g2_v2: () => import('../DevicesSettings/NightMode/NightModeG2/NightModeG2V2.svelte'),
	open_close_working_time: () => import('./Settings/SettingsG1/OpenCloseTime.svelte'),
	positioning_controls: () => import('./Settings/SettingsG1/PositioningControls.svelte'),
	power_consumption: () => import('./Settings/SettingsG1/PowerConsumption.svelte'),
	power_on_default: () => import('./Settings/SettingsG1/PowerModes/PowerOn.svelte'),
	power_on_default_1l: () => import('./Settings/SettingsG1/PowerModes/PowerOn1L.svelte'),
	power_on_default_roller: () => import('./Settings/SettingsG1/PowerModes/PowerOnRoller.svelte'),
	power_on_default_rr: () => import('./Settings/SettingsG1/PowerModes/PowerOnRR.svelte'),
	range_extenders: () => import('./Settings/SettingsG1/RangeExtenders.svelte'),
	remain_awake: () => import('./Settings/SettingsG1/RemainAwake.svelte'),
	reverse_directions: () => import('./Settings/SettingsG1/ReverseDirections.svelte'),
	thermostat_settings_g2: () =>
		import('./Settings/SettingsG2/ThermostatsWallDisplay/Thermostat.svelte'),
	media_player_settings_g2: () =>
		import('./Settings/SettingsG2/ThermostatsWallDisplay/MediaPlayerSettings.svelte'),
	thermostats_g2: () => import('./Settings/SettingsG2/ThermostatsWallDisplay/ThermostatsG2.svelte'),
	transformer_calibration: () => import('./Settings/SettingsG1/TransformerCalibration.svelte'),
	transformer_type: () => import('./Settings/SettingsG1/TransformerType.svelte'),
	transition_time: () => import('./Settings/SettingsG1/TransitionTime.svelte'),
	min_valve_trv: () => import('./Settings/SettingsG1/TRV/TRVMinValve.svelte'),
	self_test: () => import('./Settings/SettingsG1/SelfTest.svelte'),
	set_volume: () => import('./Settings/SettingsG1/SetVolume.svelte'),
	supply_voltage: () => import('./Settings/SettingsG1/SupplyVoltage.svelte'),
	swap_inputs_1l: () => import('./Settings/SettingsG1/SwapInputs1L.svelte'),
	swap_inputs: () => import('./Settings/SettingsG1/SwapInputs.svelte'),
	under_floor_heating: () => import('./Settings/SettingsG1/TRV/UnderFloorHeating.svelte'),
	warm_up: () => import('./Settings/SettingsG1/WarmUp.svelte'),
	auto_gen_2: () => import('./Timers/TimersG2/AutoG2.svelte'),
	auto_gen_2_v2: () => import('./Timers/TimersG2/AutoG2V2.svelte'),
	auto_gen_2_emeter: () => import('./Timers/TimersG2/AutoG2Emeter.svelte'),
	auto_gen_2_emeter_v2: () => import('./Timers/TimersG2/AutoG2EmeterV2.svelte'),
	auto_diffuser_gen_2: () => import('./Timers/TimersG2/AutoDiffuserG2.svelte'),
	auto_diffuser_gen_2_v2: () => import('./Timers/TimersG2/AutoDiffuserG2V2.svelte'),
	schedule_gen_2: () => import('./Schedules/SchedulesG2/SchedulesG2.svelte'),
	schedule_gen_2_v2: () => import('./Schedules/SchedulesG2/SchedulesG2V2.svelte'),
	webhooks_gen_2: () => import('./WebHooks/WebHooksG2/WebHooksG2.svelte'),
	webhooks_gen_2_v2: () => import('./WebHooks/WebHooksG2/WebHooksG2V2.svelte'),
	bluetooth_gen_2: () => import('./Settings/Bluetooth/BluetoothG2.svelte'),
	cloud_gen_2: () => import('./NetworkG2/CloudG2.svelte'),
	device_authentication_gen_2: () => import('./NetworkG2/DeviceAuthenticationG2.svelte'),
	ethernet_gen_2: () => import('./NetworkG2/EthernetG2.svelte'),
	lte_settings_gen_2: () => import('./NetworkG2/LteSettingsG2.svelte'),
	mqtt_gen_2: () => import('./NetworkG2/MqttG2.svelte'),
	local_network_messaging_g2: () => import('./NetworkG2/LocalNetworkMessagingG2.svelte'),
	outbound_ws: () => import('./NetworkG2/OutBoundWS.svelte'),
	rpc_over_udp: () => import('./NetworkG2/RpcOverUdp.svelte'),
	range_extender_g2: () => import('./NetworkG2/RangeExtender.svelte'),
	wifi_mode_ap_gen_2: () => import('./NetworkG2/WifiModeApG2.svelte'),
	wifi_client_backup_gen_2: () => import('./NetworkG2/WifiClientBackupG2.svelte'),
	wifi_mode_client_gen_2: () => import('./NetworkG2/WifiModeClientG2.svelte'),
	matter_gen_2: () => import('./NetworkG2/MatterG2.svelte'),
	max_power_protection_g2: () => import('./Safety/SafetyG2/MaxPowerProtectionG2.svelte'),
	max_current_protection_g2: () => import('./Safety/SafetyG2/MaxCurrentProtectionG2.svelte'),
	max_voltage_protection_g2: () => import('./Safety/SafetyG2/MaxVoltageProtectionG2.svelte'),
	cb_voltage_protection: () => import('./Safety/SafetyG2/CbVoltageProtection.svelte'),
	dimmer_voltage_protection: () => import('./Safety/SafetyG2/DimmerVoltageProtection.svelte'),
	addon_enable: () => import('./AddonSettingsG2/EnableAddon.svelte'),
	peripheral_device_settings: () =>
		import('./AddonSettingsG2/PeripheralDevice/PeripheralDeviceSettings.svelte'),
	plus_uni_counter: () => import('./PlusUniCounterSettings/PlusUniCounterSettings.svelte'),
	favorites_gen_2: () => import('./FavoritesG2.svelte'),
	analog_input_settings_g2: () => import('./Settings/SettingsG2/AnalogInputSettingsG2.svelte'),
	blink_mode_selector: () => import('./Settings/SettingsG2/BlinkModeSelector.svelte'),
	button_presets_g2: () => import('./Settings/SettingsG2/ButtonPresetsG2.svelte'),
	button_presets_prorgbww: () => import('./Settings/SettingsG2/ButtonPresetsProRGBWW.svelte'),
	button_presets_plus_rgbw: () => import('./Settings/SettingsG2/ButtonPresetsPlusRGBWPM.svelte'),
	channel_from_channel_calibration_g2: () =>
		import('./Settings/SettingsG2/ChannelFromChannelCalibrationG2.svelte'),
	delete_stored_data_g2: () => import('./Settings/SettingsG2/DeleteStoredDataG2.svelte'),
	reset_energy_counters_g2: () => import('./Settings/SettingsG2/ResetEnergyCountersG2.svelte'),
	emeter_led_indicator: () => import('./Settings/SettingsG2/EmeterLedIndicator.svelte'),
	emeter_measurement: () => import('./Settings/SettingsG2/EmeterMeasurement.svelte'),
	emeter_calibration: () => import('./Settings/SettingsG2/EmeterCalibration.svelte'),
	emeter_stored_data: () => import('./Settings/SettingsG2/EmeterStoredData.svelte'),
	emeter_alarms: () => import('./Settings/SettingsG2/EmeterAlarms.svelte'),
	device_name_g2: () => import('./Settings/SettingsG2/ChannelNameG2.svelte'),
	device_name_sys: () => import('./Settings/SettingsG2/DeviceNameSys.svelte'),
	dimmer_calibrate_g2: () => import('./Settings/SettingsG2/DimmerCalibrateG2.svelte'),
	high_frequency_mode_g2: () => import('./Settings/SettingsG2/HighFrequencyModeG2.svelte'),
	input_name_g2: () => import('./Settings/SettingsG2/InputNameG2.svelte'),
	input_output_plug: () => import('./Settings/SettingsG2/InputOutputSettings/InputOutputPlug.svelte'),
	input_output_g2: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG2.svelte'),
	lock_inputs_g2: () => import('./Settings/SettingsG2/InputOutputSettings/LockInputsG2.svelte'),
	apply_settings_configuration: () => import('./Settings/SettingsG2/ApplySettingsConfig.svelte'),
	virtual_input_g2: () => import('./Settings/SettingsG2/InputOutputSettings/VirtualInput.svelte'),
	assigned_bluetooth_devices_gen_2: () => import('./Settings/Bluetooth/BTAssignedDevices.svelte'),
	bt_home_control_gen_2: () => import('./Settings/Bluetooth/BTRemoteControls.svelte'),
	bluetooth_rpc_tester: () => import('./Settings/Bluetooth/BluetoothRpcTester.svelte'),
	input_output_010: () => import('./Settings/SettingsG2/InputOutputSettings/InputOutput010.svelte'),
	input_output_g2_rgbw: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG2RGBW.svelte'),
	input_invert_per_id_g2: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputInvertPerIDG2.svelte'),
	input_name_per_id_g2: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputNamePerIDG2.svelte'),
	input_type_per_id_g2: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputTypePerIDG2.svelte'),
	button_fade_rate_g2: () => import('./Settings/SettingsG2/ButtonFadeRateG2.svelte'),
	min_brightness_on_toggle_g2: () => import('./Settings/SettingsG2/MinBrightnessOnToggleG2.svelte'),
	gamma_dimmer_g2: () => import('./Settings/SettingsG2/GammaDimmerG2.svelte'),
	operational_mode_g2: () => import('./Settings/SettingsG2/OperationalModeG2.svelte'),
	operational_counters_g2: () => import('./Settings/SettingsG2/OperationalCountersG2.svelte'),
	range_map_g2: () => import('./Settings/SettingsG2/RangeMapG2.svelte'),
	ct_range_g2: () => import('./Settings/SettingsG2/CTRangeG2.svelte'),
	reaction_delay_g2: () => import('./Settings/SettingsG2/ReactionDelay.svelte'),
	reverse_measurement_direction_g2: () =>
		import('./Settings/SettingsG2/ReverseMeasurementDirectionG2.svelte'),
	reverse_measurement_direction_g2_plug_pm: () =>
		import('./Settings/SettingsG2/ReverseMeasurementDirectionG2PlugPm.svelte'),
	reverse_measurement_direction_g2_pm: () =>
		import('./Settings/SettingsG2/ReverseMeasurementDirectionG2Pm.svelte'),
	reverse_measurement_direction_monophase: () =>
		import('./Settings/SettingsG2/ReverseMeasurementDirectionMonophase.svelte'),
	daisy_em_tariff: () => import('./Settings/SettingsG2/DaisyEMTariffSettings.svelte'),
	change_ct_type: () => import('./Settings/SettingsG2/ChangeCTType.svelte'),
	default_transition_g2: () => import('./Settings/SettingsG2/DefaultTransitionG2.svelte'),
	transition_g2: () => import('./Settings/SettingsG2/TransitionG2.svelte'),
	invert_switch_g2: () => import('./Settings/SettingsG2/InputOutputSettings/InvertSwitchG2.svelte'),
	enable_input_g2: () => import('./Settings/SettingsG2/InputOutputSettings/EnableInputG2.svelte'),
	enable_input_by_id_g2: () =>
		import('./Settings/SettingsG2/InputOutputSettings/EnableInputByIdG2.svelte'),
	invert_input_by_id_g2: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InvertInputByIdG2.svelte'),
	input_output_wall_switch_us_g3: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputOutputWallSwitchUSG3.svelte'),
	input_output_wall_display: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputOutputWallDisplay.svelte'),
	wall_switch_ui_g3: () => import('./Settings/SettingsG2/WallSwitchUIG3.svelte'),
	enable_input_per_id_g2: () => import('./Settings/SettingsG2/EnableInputPerIDG2.svelte'),
	detach_switch_g2: () => import('./Settings/SettingsG2/InputOutputSettings/DetachSwitchPlugS.svelte'),
	display_mode_g2: () => import('./Settings/SettingsG2/DisplayModeG2.svelte'),
	eco_mode_g2: () => import('./Settings/SettingsG2/EcoModeG2.svelte'),
	enhanced_security_g2: () => import('./Settings/SettingsG2/EnhancedSecurityG2.svelte'),
	boost_time_diffuser_gen_2: () => import('./Settings/SettingsG2/BoostDiffuserG2.svelte'),
	ventora_fan_boost_defaults: () =>
		import('./Settings/SettingsG2/VentoraFan/VentoraFanBoostDefaults.svelte'),
	ventora_fan_hum_trigger: () =>
		import('./Settings/SettingsG2/VentoraFan/VentoraFanHumTrigger.svelte'),
	ventora_fan_idle_refresh: () =>
		import('./Settings/SettingsG2/VentoraFan/VentoraFanIdleRefresh.svelte'),
	ventora_fan_in_mode: () => import('./Settings/SettingsG2/VentoraFan/VentoraFanInMode.svelte'),
	ventora_fan_light_trigger: () =>
		import('./Settings/SettingsG2/VentoraFan/VentoraFanLightTrigger.svelte'),
	ventora_fan_night_mode: () => import('./Settings/SettingsG2/VentoraFan/VentoraFanNightMode.svelte'),
	ventora_fan_run_mode: () => import('./Settings/SettingsG2/VentoraFan/VentoraFanRunMode.svelte'),
	ventora_fan_temp_trigger: () =>
		import('./Settings/SettingsG2/VentoraFan/VentoraFanTempTrigger.svelte'),
	cover_profile: () => import('./Settings/SettingsG2/CoverProfile.svelte'),
	rgbw_g2_profile: () => import('./Settings/SettingsG2/RGBWG2Profile.svelte'),
	pro3em_profile: () => import('./Settings/SettingsG2/Pro3EmProfile.svelte'),
	led_indicators_g2: () => import('./Settings/SettingsG2/LedIndicatorsG2.svelte'),
	led_indicators_g2_cury: () => import('./Settings/SettingsG2/LedIndicatorsG2Cury.svelte'),
	vial_auto_switching_g2_cury: () => import('./Settings/SettingsG2/VialAutoSwitchingG2Cury.svelte'),
	device_mode_g2_cury: () => import('./Settings/SettingsG2/DeviceModeG2Cury.svelte'),
	location_g2: () => import('./Settings/SettingsG2/LocationG2.svelte'),
	scripts_gen_2: () => import('./Scripts/Scripts.svelte'),
	scripts_gen_2_v2: () => import('./Scripts/Scripts.svelte'),
	warm_up_dimmer_g2: () => import('./Settings/SettingsG2/WarmUpDimmerG2.svelte'),
	soft_reboot_g2: () => import('./Settings/SettingsG2/SoftRebootG2.svelte'),
	input_type_g2: () => import('./Settings/SettingsG2/InputOutputSettings/InputTypeG2.svelte'),
	input_type_wall_display: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputTypeWallDisplay.svelte'),
	output_type_g2: () => import('./Settings/SettingsG2/InputOutputSettings/OutputTypeG2.svelte'),
	offline_notifications_settings: () =>
		import('./ApplicationSettings/NotificationSettings/OfflineNotificationsSetting.svelte'),
	lowBattery_notifications_settings: () =>
		import('./ApplicationSettings/NotificationSettings/LowBatteryNotificationsSetting.svelte'),
	voltmeter_settings_per_id_g2: () =>
		import('./Settings/SettingsG2/InputOutputSettings/VoltmeterSettingsPerIDG2.svelte'),
	action_on_power_on_g2_cover: () => import('./Settings/SettingsG2/ActionPowerOnG2Cover.svelte'),
	action_on_power_on_g2: () => import('./Settings/SettingsG2/ActionPowerOnG2.svelte'),
	action_on_power_on_g2_emeter: () => import('./Settings/SettingsG2/ActionOnPowerOnG2Emeter.svelte'),
	calibration_g2: () => import('./Settings/SettingsG2/CalibrationG2.svelte'),
	control_button_mode_g2: () => import('./Settings/SettingsG2/ControlButtonModeG2.svelte'),
	frequency_listener_g2: () => import('./Settings/SettingsG2/FrequencyListenerG2.svelte'),
	input_type_g2_cover: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputTypeG2cover.svelte'),
	input_type_g2_dual_cover: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputTypeG2DualCover.svelte'),
	invert_switch_per_id_g2: () => import('./Settings/SettingsG2/InvertSwitchG2PerIDG2.svelte'),
	monitor_phase_sequence_g2: () => import('./Settings/SettingsG2/MonitorPhaseSequence.svelte'),
	movement_time_limits_g2: () => import('./Settings/SettingsG2/MovementTimeLimitsG2.svelte'),
	obstacle_detection_g2: () => import('./Safety/SafetyG2/ObstacleDetectiong2.svelte'),
	phase_selector: () => import('./Settings/SettingsG2/PhaseSelector.svelte'),
	phase_calibration: () => import('./Settings/SettingsG2/PhaseCalibration.svelte'),
	phase_calibration_reset_g2: () => import('./Settings/SettingsG2/PhaseResetG2.svelte'),
	phase_to_phase_g2: () => import('./Settings/SettingsG2/PhaseToPhaseG2.svelte'),
	reverse_direction_g2: () => import('./Settings/SettingsG2/ReverseDirectionG2.svelte'),
	swap_inputs_g2: () => import('./Settings/SettingsG2/SwapInputsG2.svelte'),
	safety_switch_g2: () => import('./Safety/SafetyG2/SafetySwitchG2.svelte'),
	gesture_control_g2: () => import('./Settings/SettingsG2/Raex/RaexGestureControlG2.svelte'),
	motor_speed_g2: () => import('./Settings/SettingsG2/Raex/RaexMotorSpeedG2.svelte'),
	screen_lock_g2: () => import('./Settings/SettingsG2/ScreenLockG2.svelte'),
	screen_off_g2: () => import('./Settings/SettingsG2/ScreenOffG2.svelte'),
	dim_screen_after_g2: () => import('./Settings/SettingsG2/DimScreenAfterG2.svelte'),
	sys_btn_toggle_g2: () => import('./Settings/SettingsG2/SysBtnToggleG2.svelte'),
	screen_saver_g2: () => import('./Settings/SettingsG2/ScreenSaverG2.svelte'),
	blinds_tilt_control_g2: () => import('./Settings/SettingsG2/TiltControl.svelte'),
	ui_settings_g2: () => import('./Settings/SettingsG2/UISettingsG2.svelte'),
	idle_power_threshold_g2: () => import('./Settings/SettingsG2/IdlePowerThreshold.svelte'),
	idle_confirm_period_g2: () => import('./Settings/SettingsG2/IdleConfirmPeriod.svelte'),
	inputs_configuration_g2: () => import('./Settings/SettingsG2/Raex/RaexInputsConfigurationG2.svelte'),
	dali_configuration: () => import('./Settings/SettingsG3/DaliConfiguration.svelte'),
	rgbww_g3_profile: () => import('./Settings/SettingsG2/ProRGBWWPMProfile.svelte'),
	input_output_g3_rgbww: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG3RGBWW.svelte'),
	input_output_g3_dimmer: () =>
		import('./Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG3Dimmer.svelte'),
	device_led_sys_gw: () => import('./Settings/SettingsG3/DeviceLedSysGW.svelte'),
	pill_peripheral_settings: () =>
		import('./AddonSettingsG2/PillPeripherals/PillPeripheralSettings.svelte'),
	find_ble: () => import('./SettingsGBLE/ButtonFindMe.svelte'),
	motion_sensitivity_ble: () => import('./SettingsGBLE/MotionSensitivity.svelte'),
	motion_blind_time_ble: () => import('./SettingsGBLE/MotionBlindTime.svelte'),
	firmware_update_ble: () => import('./SettingsGBLE/FirmwareUpdate.svelte'),
	factory_reset_ble: () => import('./SettingsGBLE/FactoryReset.svelte'),
	distance_unit_ble: () => import('./SettingsGBLE/DistanceUnit.svelte'),
	distance_range_ble: () => import('./SettingsGBLE/DistanceRange.svelte'),
	measurement_interval_ble: () => import('./SettingsGBLE/MeasurementInterval.svelte'),
	angle_report_threshold_ble: () => import('./SettingsGBLE/AngleReportThreshold.svelte'),
	weather_station_device_location: () =>
		import('../WeatherStation/WeatherStationDeviceLocation.svelte'),
	weather_station_ble_settings: () =>
		import('../WeatherStation/Settings/WeatherStationBLESettings.svelte'),
	temperature_offset_ble: () =>
		import('./SettingsGBLE/OffsetThresholdGBLE/TemperatureOffsetGBLE.svelte'),
	humidity_offset_ble: () => import('./SettingsGBLE/OffsetThresholdGBLE/HumidityOffsetGBLE.svelte'),
	utc_offset_ble: () => import('./SettingsGBLE/OffsetThresholdGBLE/UtcOffsetGBLE.svelte'),
	dark_threshold_ble: () => import('./SettingsGBLE/OffsetThresholdGBLE/DarkThresholdGBLE.svelte'),
	bright_threshold_ble: () => import('./SettingsGBLE/OffsetThresholdGBLE/BrightThresholdGBLE.svelte'),
	temperature_threshold_ble: () =>
		import('./SettingsGBLE/OffsetThresholdGBLE/TemperatureTresholdGBLE.svelte'),
	smoke_threshold_ble: () => import('./SettingsGBLE/OffsetThresholdGBLE/SmokeThresholdGBLE.svelte'),
	clock_format_ble: () => import('./SettingsGBLE/ClockFormatGBLE.svelte'),
	fire_group_ble: () => import('./SettingsGBLE/FireGroupGBLESetting.svelte'),
	min_charge: () => import('../Integrations/Zendure/MinCharge.svelte'),
	max_charge: () => import('../Integrations/Zendure/MaxCharge.svelte'),
	output_limit: () => import('../Integrations/Zendure/OutputLimitVisualizer.svelte'),
	input_limit: () => import('../Integrations/Zendure/InputLimit.svelte'),
	camera_zones: () => import('../Camera/DeviceDrawer/CameraZones/CameraZonesSettings.svelte'),
	camera_streams: () => import('../Camera/DeviceDrawer/CameraSettings/CameraStreamsSettings.svelte'),
	camera_audio: () => import('../Camera/DeviceDrawer/CameraSettings/CameraAudioSettings.svelte'),
	camera_video_adjustments: () =>
		import('../Camera/DeviceDrawer/CameraSettings/CameraVideoAdjustmentsSettings.svelte'),
	camera_image_adjustments: () =>
		import('../Camera/DeviceDrawer/CameraSettings/CameraImageAdjustmentsSettings.svelte'),
	camera_picture: () => import('../Camera/DeviceDrawer/CameraSettings/CameraPictureSettings.svelte'),
	camera_night_vision: () =>
		import('../Camera/DeviceDrawer/CameraSettings/CameraNightVisionSettings.svelte'),
	camera_motion_detection: () =>
		import('../Camera/DeviceDrawer/CameraSettings/CameraMotionDetectionSettings.svelte'),
	camera_status_led: () =>
		import('../Camera/DeviceDrawer/CameraSettings/CameraStatusLedSettings.svelte'),
	camera_storage: () =>
		import('../Camera/DeviceDrawer/CameraSettings/CameraStorage/CameraStorageSettings.svelte'),
	share: () => import('./Share/Share.svelte'),
	appliance_type: () => import('../DevicesSettings/Settings/CommonSettings/ApplianceType.svelte'),
	consumption_calculation: () => import('./ApplicationSettings/ConsumptionCalculation.svelte'),
	exclude_event_log: () => import('./ApplicationSettings/ExcludeEventLog.svelte'),
	exclude_forgotten_lights: () => import('./ApplicationSettings/ExcludeForgottenLights.svelte'),
	pin_lock: () => import('./ApplicationSettings/PinLock.svelte'),
	input_state: () => import('./ApplicationSettings/InputState.svelte'),
	ai_model: () => import('./ApplicationSettings/AIModel/AIModel.svelte'),
	consumption_hierarchy: () => import('./ApplicationSettings/ConsumptionHierarchy.svelte'),
	device_split: () => import('./ApplicationSettings/SplitEmeters.svelte'),
	virtual_components: () => import('./VirtualComponents/VirtualComponents.svelte'),
	virtual_components_v2: () => import('./VirtualComponents/ComponentsV2/VirtualComponentsV2.svelte'),
	irrigation_zones_settings: () => import('../XT1/Irrigation/IrrigationZonesSettings.svelte'),
	irrigation_sequences: () => import('../XT1/Irrigation/IrrigationSequences.svelte'),
	irrigation_duration_offset: () => import('../XT1/Irrigation/IrrigationDurationOffset.svelte'),
	limit_enabled_channels: () => import('../XT1/Irrigation/IrrigationLimitEnabledZones.svelte'),
	enable_weather_api: () => import('../XT1/Irrigation/EnableWeatherAPI.svelte'),
	base_temperature: () => import('../XT1/Irrigation/BaseTemperature.svelte'),
	valve_action_on_power_lost: () => import('../XT1/Valve/ValveActionOnPowerLost.svelte'),
	valve_action_on_power_restored: () => import('../XT1/Valve/ValveActionOnPowerRestored.svelte'),
	valve_neo_valve_settings: () => import('../XT1/NeoValve/NeoValveSettings.svelte'),
	thermostat_child_lock: () => import('../XT1/Thermostat/ThermostatChildLock.svelte'),
	thermostat_anti_freeze: () => import('../XT1/Thermostat/ThermostatAntiFreeze.svelte'),
	thermostat_power_down_memory: () => import('../XT1/Thermostat/ThermostatPowerDownMemory.svelte'),
	thermostat_temperature_unit: () => import('../XT1/Thermostat/ThermostatTemperatureUnit.svelte'),
	thermostat_anti_freeze_temp: () =>
		import('../XT1/Thermostat/ThermostatAntiFreezeTemperature.svelte'),
	thermostat_temperature_offset: () => import('../XT1/Thermostat/ThermostatTemperatureOffset.svelte'),
	thermostat_humidity_offset: () => import('../XT1/Thermostat/ThermostatHumidityOffset.svelte'),
	thermostat_hysteresis: () => import('../XT1/Thermostat/ThermostatHysteresis.svelte'),
	thermostat_temperature_settings: () =>
		import('../XT1/Thermostat/ThermostatTemperatureSettings.svelte'),
	ev_charger_auto_balance: () => import('../XT1/EvCharger/Settings/EvChargerAutoBalance.svelte'),
	ev_charger_auto_charge: () => import('../XT1/EvCharger/Settings/EvChargerAutoCharge.svelte'),
	ev_charger_global_charge_limit: () =>
		import('../XT1/EvCharger/Settings/EvChargerGlobalChargeLimit.svelte'),
	ev_charger_global_time_limit: () =>
		import('../XT1/EvCharger/Settings/EvChargerGlobalTimeLimit.svelte'),
	ev_charger_insert_handshake: () =>
		import('../XT1/EvCharger/Settings/EvChargerInsertHandshake.svelte'),
	ev_charger_randomize_delay: () => import('../XT1/EvCharger/Settings/EvChargerRandomizeDelay.svelte'),
	dehumidifier_auto_off_delay: () => import('../XT1/Dehumidifier/AutoOffDehumidifier.svelte'),
	auto_gen_z: () => import('./Timers/TimersZ/AutoZ.svelte'),
	calibration_z: () => import('./Settings/SettingsZWave/CalibrationZ.svelte'),
	channel_name_z: () => import('./Settings/SettingsZWave/ChannelNameZ.svelte'),
	co_alarm_z: () => import('./Settings/SettingsZWave/COAlarmZ.svelte'),
	factory_reset_z: () => import('./Settings/SettingsZWave/FactoryResetZ.svelte'),
	zwave_reboot_z: () => import('./Settings/SettingsZWave/RebootZ.svelte'),
	zwave_reinterview_z: () => import('./Settings/SettingsZWave/ReinterviewZ.svelte'),
	zwave_remove_failed_z: () => import('./Settings/SettingsZWave/RemoveFailedZ.svelte'),
	zwave_include_exclude: () => import('./Settings/SettingsZWave/ZWaveIncludeExclude.svelte'),
	zwave_missing_devices: () => import('./Settings/SettingsZWave/ZWaveMissingDevices.svelte'),
	zwave_hard_reset: () => import('./Settings/SettingsZWave/ZWaveHardReset.svelte'),
	firmware_update_z: () => import('./Settings/SettingsZWave/FirmwareUpdateZ.svelte'),
	heat_alarm_z: () => import('./Settings/SettingsZWave/HeatAlarmZ.svelte'),
	idle_power_period_z: () => import('./Settings/SettingsZWave/IdlePowerPeriodZ.svelte'),
	input_type_z: () => import('./Settings/SettingsZWave/InputTypeZ.svelte'),
	invert_output_z: () => import('./Settings/SettingsZWave/InvertOutputZ.svelte'),
	movement_time_limits_z: () => import('./Settings/SettingsZWave/MovementTimeLimitsZ.svelte'),
	power_on_default_z: () => import('./Settings/SettingsZWave/PowerOnDefaultZ.svelte'),
	smoke_alarm_z: () => import('./Settings/SettingsZWave/SmokeAlarmZ.svelte'),
	swap_inputs_z: () => import('./Settings/SettingsZWave/SwapInputZ.svelte'),
	swap_outputs_z: () => import('./Settings/SettingsZWave/SwapOutputZ.svelte'),
	water_alarm_z: () => import('./Settings/SettingsZWave/WaterAlarmZ.svelte'),
	wave_configuration_param_z: () => import('./Settings/SettingsZWave/WaveConfigurationParamZ.svelte'),
} satisfies Record<string, ComponentLoader>;

export type SettingsComponentKey = keyof typeof SETTINGS_COMPONENT_LOADERS_BY_KEY;
export const SETTINGS_COMPONENT_LOADERS: Record<string, ComponentLoader> =
	SETTINGS_COMPONENT_LOADERS_BY_KEY;
